
import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { connect } from 'react-redux';
import { setBreadcrumbItems } from "../../store/actions";


const API = process.env.REACT_APP_API;

const Modal = ({ show, onClose, children }) => {




  if (!show) return null;
  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999
    }}>
      <div style={{ background: '#fff', padding: 25, borderRadius: 8, minWidth: 350, maxWidth: 600 }}>
        <button className="btn btn-sm btn-secondary float-end" onClick={onClose}>X</button>
        {children}
      </div>
    </div>
  );
};

const Listado = (props) => {
  document.title = "Socios  | Listado - Ges Sindical";

  const breadcrumbItems = [
    { title: "Socios", link: "#" },
    { title: "Listado", link: "#" },
  ];

  useEffect(() => {
    props.setBreadcrumbItems('Listado Socios', breadcrumbItems);
  }, []);

  const [socios, setSocios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedSocio, setSelectedSocio] = useState(null);
  const [pagoInfo, setPagoInfo] = useState(null);
  const [pagando, setPagando] = useState(false);
  const [montos, setMontos] = useState({});
  const [tipoPago, setTipoPago] = useState('total');
  const [montoParcial, setMontoParcial] = useState('');
  const [metodosPago, setMetodosPago] = useState([]);
  const [metodoSeleccionado, setMetodoSeleccionado] = useState('');


 

  useEffect(() => {
  setLoading(true);
  fetch(`${API}/api/members/responsables`)
    .then(async res => {
      const contentType = res.headers.get("content-type");
      if (!contentType || !contentType.includes("application/json")) {
        throw new Error("La respuesta no es JSON. Verificá el endpoint del backend.");
      }
      const data = await res.json();
      setSocios(Array.isArray(data) ? data : []);
      setLoading(false);

      // Consultar el saldo pendiente para cada socio
      const nuevosMontos = {};
      for (let s of data) {
        try {
          const resPago = await fetch(`${API}/api/payments/payment-info/${s.id || s._id}`);
          const dataPago = await resPago.json();
          if (dataPago.type === 'familiar') {
            nuevosMontos[s.id || s._id] = {
              total: dataPago.totalFamilia,
              saldoPendiente: dataPago.saldoPendiente,
              debe: dataPago.debe
            };
          } else if (dataPago.type === 'individual') {
            nuevosMontos[s.id || s._id] = {
              total: dataPago.finalAmount ?? dataPago.baseAmount ?? 0,
              saldoPendiente: dataPago.saldoPendiente,
              debe: dataPago.debe
            };
          } else {
            nuevosMontos[s.id || s._id] = { total: null, saldoPendiente: null, debe: null };
          }
        } catch (e) {
          nuevosMontos[s.id || s._id] = { total: null, saldoPendiente: null, debe: null };
        }
      }
      setMontos(nuevosMontos);
    })
    .catch(error => {
      console.error("Error al obtener socios:", error);
      Swal.fire({
        icon: 'error',
        title: 'Error al cargar socios',
        text: error.message || 'No se pudo obtener la lista de socios.',
      });
      setLoading(false);
    });
}, []);


  // Modal: Al abrir, consultá info de pago y métodos de pago, resetea tipo de pago
  const handleAbrirPago = async (socio) => {
    setSelectedSocio(socio);
    setPagoInfo(null);
    setModalOpen(true);
    setTipoPago('total');
    setMontoParcial('');
    setMetodoSeleccionado('');
    try {
      const res = await fetch(`${API}/api/payments/payment-info/${socio.id || socio._id}`);
      const data = await res.json();
      setPagoInfo(data);

      // El monto a pagar por defecto es el saldo pendiente si debe
      setMontoParcial(data.saldoPendiente || '');

      // Traer métodos de pago
      const resMetodos = await fetch(`${API}/api/payment-methods`);
      const metodos = await resMetodos.json();
      if (Array.isArray(metodos) && metodos.length > 0) {
        setMetodosPago(metodos.filter(m => m.status !== false));
        setMetodoSeleccionado(metodos[0]._id);
      } else {
        setMetodosPago([]);
        setMetodoSeleccionado('');
        Swal.fire({
          icon: 'warning',
          title: 'No hay métodos de pago configurados',
          text: 'Por favor configure métodos de pago desde el panel de configuración.',
        });
      }
    } catch (error) {
      setPagoInfo({ error: 'No se pudo consultar información de pago.' });
    }
  };

  // Confirmar pago (total o parcial)
  const handlePagar = async (e) => {
    e && e.preventDefault();

    if (!pagoInfo || !selectedSocio) return;
    if (!metodoSeleccionado) {
      Swal.fire({
        icon: 'warning',
        title: 'Seleccione un método de pago',
        text: 'Debe elegir un método de pago para continuar.',
      });
      return;
    }
    setPagando(true);

    const saldoPendiente = pagoInfo.saldoPendiente ?? (
      pagoInfo.type === 'familiar'
        ? pagoInfo.totalFamilia
        : pagoInfo.finalAmount ?? pagoInfo.baseAmount ?? 0
    );

    let esParcial = tipoPago === 'parcial';
    let monto = esParcial ? Number(montoParcial) : saldoPendiente;

    if (esParcial) {
      if (!monto || isNaN(monto) || monto < 1 || monto >= saldoPendiente) {
        setPagando(false);
        Swal.fire({
          icon: 'warning',
          title: 'Monto inválido',
          text: `Ingrese un monto mayor a 0 y menor que $${saldoPendiente}`,
        });
        return;
      }
    }

    try {
      const res = await fetch(`${API}/api/payments/universal`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          memberId: selectedSocio.id || selectedSocio._id,
          paymentMethod: metodoSeleccionado,
          isPartial: esParcial,
          amount: monto
        })
      });
      const data = await res.json();
      setPagando(false);

      if (res.ok) {
        Swal.fire({
          icon: 'success',
          title: 'Pago registrado correctamente',
          showConfirmButton: false,
          timer: 1800
        });
        setModalOpen(false);
        // Refrescar listado y montos
        fetch(`${API}/api/members/responsables`)
          .then(res => res.json())
          .then(async data => {
            setSocios(Array.isArray(data) ? data : []);
            // Volver a calcular el saldo pendiente
            const nuevosMontos = {};
            for (let s of data) {
              try {
                const resPago = await fetch(`${API}/api/payments/payment-info/${s.id || s._id}`);
                const dataPago = await resPago.json();
                if (dataPago.type === 'familiar') {
                  nuevosMontos[s.id || s._id] = {
                    total: dataPago.totalFamilia,
                    saldoPendiente: dataPago.saldoPendiente,
                    debe: dataPago.debe
                  };
                } else if (dataPago.type === 'individual') {
                  nuevosMontos[s.id || s._id] = {
                    total: dataPago.finalAmount ?? dataPago.baseAmount ?? 0,
                    saldoPendiente: dataPago.saldoPendiente,
                    debe: dataPago.debe
                  };
                } else {
                  nuevosMontos[s.id || s._id] = { total: null, saldoPendiente: null, debe: null };
                }
              } catch (e) {
                nuevosMontos[s.id || s._id] = { total: null, saldoPendiente: null, debe: null };
              }
            }
            setMontos(nuevosMontos);
          });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error al pagar',
          text: data.error || "Ocurrió un problema",
        });
      }
    } catch (error) {
      setPagando(false);
      Swal.fire({
        icon: 'error',
        title: 'Error de red',
        text: 'No se pudo conectar al servidor.',
      });
    }
  };

  // --- Formulario del modal de pago (total/parcial) ---
  // const renderFormularioPago = () => {
  //   if (!pagoInfo) return null;

  //   const montoTotal = pagoInfo.type === 'familiar'
  //     ? pagoInfo.totalFamilia
  //     : pagoInfo.finalAmount ?? pagoInfo.baseAmount ?? 0;

  //   const saldoPendiente = pagoInfo.saldoPendiente ?? montoTotal;

  //   return (
  //     <>
  //       <h4>Información de Pago</h4>
  //       {pagoInfo.type === "individual" && (
  //         <>
  //           <p><b>Socio:</b> {pagoInfo.member.name}</p>
  //           <p><b>Monto:</b>  <span className="font-bold font-size-20 pl-5"> ${pagoInfo.baseAmount}</span></p>
  //           <p><b>Pagado este mes:</b> ${pagoInfo.pagadoEsteMes ?? 0}</p>
  //           <p><b>Saldo pendiente:</b> <span className="font-bold">${saldoPendiente}</span></p>
  //         </>
  //       )}
  //       {pagoInfo.type === "familiar" && (
  //         <>
  //           <p>
  //             <b>Responsable de Pago:</b> {pagoInfo.responsable?.name}
  //           </p>
  //           <p>
  //             <b>Hermanos en grupo:</b>{" "}
  //             {pagoInfo.grupo.map(m => m.name).join(', ')}
  //           </p>
  //           <table className="table table-sm">
  //             <thead>
  //               <tr>
  //                 <th>Socio</th>
  //                 <th>Cuota</th>
  //                 <th>Descuentos</th>
  //                 <th>% Total</th>
  //                 <th>Descuento $</th>
  //                 <th>Total</th>
  //               </tr>
  //             </thead>
  //             <tbody>
  //               {pagoInfo.grupo.map(m => (
  //                 <tr key={m.id}>
  //                   <td>{m.name}{m.isPaymentResponsible ? " (Responsable)" : ""}</td>
  //                   <td>${m.baseAmount}</td>
  //                   <td>
  //                     {m.discountNames && m.discountNames.length > 0
  //                       ? m.discountNames.join(' + ')
  //                       : "Sin descuento"}
  //                   </td>
  //                   <td>
  //                     {m.discountPercentage > 0 ? m.discountPercentage + '%' : ''}
  //                   </td>
  //                   <td>${m.discountAmount}</td>
  //                   <td>${m.finalAmount}</td>
  //                 </tr>
  //               ))}
  //             </tbody>
  //           </table>
  //           <p>
  //             <b>Total Familiar:</b>{" "}
  //             <span className="font-bold font-size-20 pl-5">${montoTotal}</span>
  //           </p>
  //           <p>
  //             <b>Pagado este mes:</b> ${pagoInfo.pagadoEsteMes ?? 0}
  //           </p>
  //           <p>
  //             <b>Saldo pendiente:</b> <span className="font-bold">${saldoPendiente}</span>
  //           </p>
  //         </>
  //       )}

  //       {pagoInfo.debe && (
  //         <form onSubmit={handlePagar}>
  //           <div className="mb-3">
  //             <label className="me-3">
  //               <input
  //                 type="radio"
  //                 name="tipoPago"
  //                 value="total"
  //                 checked={tipoPago === 'total'}
  //                 onChange={() => {
  //                   setTipoPago('total');
  //                   setMontoParcial(saldoPendiente);
  //                 }}
  //               /> Pago Total
  //             </label>
  //             <label className="ms-3">
  //               <input
  //                 type="radio"
  //                 name="tipoPago"
  //                 value="parcial"
  //                 checked={tipoPago === 'parcial'}
  //                 onChange={() => {
  //                   setTipoPago('parcial');
  //                   setMontoParcial('');
  //                 }}
  //               /> Pago Parcial
  //             </label>
  //           </div>
  //           {tipoPago === 'parcial' && (
  //             <div className="mb-3">
  //               <label>Monto a abonar:</label>
  //               <input
  //                 type="number"
  //                 className="form-control"
  //                 min={1}
  //                 max={saldoPendiente - 1}
  //                 step={1}
  //                 value={montoParcial}
  //                 onChange={e => setMontoParcial(e.target.value)}
  //                 required
  //               />
  //               <small className="text-muted">
  //                 Debe ser menor a ${saldoPendiente}
  //               </small>
  //             </div>
  //           )}
  //           <div className="mb-3">
  //             <label>Método de Pago:</label>
  //             <select
  //               className="form-control"
  //               value={metodoSeleccionado}
  //               onChange={e => setMetodoSeleccionado(e.target.value)}
  //               required
  //             >
  //               <option value="">Seleccione un método...</option>
  //               {metodosPago.map(m => (
  //                 <option key={m._id} value={m._id}>{m.name}</option>
  //               ))}
  //             </select>
  //           </div>
  //           <button
  //             type="submit"
  //             className="btn btn-success w-100"
  //             disabled={pagando}
  //           >
  //             {pagando ? "Procesando..." : "Realizar Pago"}
  //           </button>
  //         </form>
  //       )}
  //       {!pagoInfo.debe && (
  //         <div className="alert alert-success mt-3">
  //           <b>¡Este socio está al día!</b>
  //         </div>
  //       )}
  //     </>
  //   );
  // };
// ...todo el código original se mantiene igual hasta la función renderFormularioPago

// const renderFormularioPago = () => {
//   if (!pagoInfo) return null;

//   const montoTotal = pagoInfo.type === 'familiar'
//     ? pagoInfo.totalFamilia
//     : pagoInfo.finalAmount ?? pagoInfo.baseAmount ?? 0;

//   const saldoPendiente = pagoInfo.saldoPendiente ?? montoTotal;

//   return (
//     <>
//       <h4 className="mb-3 text-primary">💰 Información de Pago</h4>
//       {pagoInfo.type === "individual" && (
//         <div style={{ backgroundColor: "#f8f9fa", padding: "15px", borderRadius: "6px" }}>
//           <p><strong>👤 Socio:</strong> {pagoInfo.member.name}</p>
//           <p><strong>💵 Monto Base:</strong> <span style={{ fontSize: "1.4rem", fontWeight: "bold" }}>${pagoInfo.baseAmount}</span></p>
//           <p><strong>🧾 Pagado este mes:</strong> ${pagoInfo.pagadoEsteMes ?? 0}</p>
//           <p><strong>📉 Saldo pendiente:</strong> <span className="text-danger fw-bold">${saldoPendiente}</span></p>
//         </div>
//       )}
//       {pagoInfo.type === "familiar" && (
//         <div style={{ backgroundColor: "#f1f3f5", padding: "15px", borderRadius: "6px" }}>
//           <p><strong>👨‍👩‍👧 Responsable de Pago:</strong> {pagoInfo.responsable?.name}</p>
//           <p><strong>🧒 Hermanos en grupo:</strong> {pagoInfo.grupo.map(m => m.name).join(', ')}</p>
//           <table className="table table-bordered table-sm mt-2">
//             <thead className="table-light">
//               <tr>
//                 <th>Socio</th>
//                 <th>Cuota</th>
//                 <th>Descuentos</th>
//                 <th>% Total</th>
//                 <th>Descuento $</th>
//                 <th>Total</th>
//               </tr>
//             </thead>
//             <tbody>
//               {pagoInfo.grupo.map(m => (
//                 <tr key={m.id}>
//                   <td>{m.name}{m.isPaymentResponsible ? " (Responsable)" : ""}</td>
//                   <td>${m.baseAmount}</td>
//                   <td>{m.discountNames?.length > 0 ? m.discountNames.join(' + ') : "Sin descuento"}</td>
//                   <td>{m.discountPercentage > 0 ? `${m.discountPercentage}%` : ''}</td>
//                   <td>${m.discountAmount}</td>
//                   <td><strong>${m.finalAmount}</strong></td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//           <p><strong>💵 Total Familiar:</strong> <span style={{ fontSize: "1.6rem", fontWeight: "bold", color: "#198754" }}>${montoTotal}</span></p>
//           <p><strong>🧾 Pagado este mes:</strong> ${pagoInfo.pagadoEsteMes ?? 0}</p>
//           <p><strong>📉 Saldo pendiente:</strong> <span className="text-danger fw-bold">${saldoPendiente}</span></p>
//         </div>
//       )}

//       {pagoInfo.debe && (
//         <form onSubmit={handlePagar} className="mt-3">
//           <div className="mb-3">
//             <label className="me-3">
//               <input
//                 type="radio"
//                 name="tipoPago"
//                 value="total"
//                 checked={tipoPago === 'total'}
//                 onChange={() => {
//                   setTipoPago('total');
//                   setMontoParcial(saldoPendiente);
//                 }}
//               /> <strong>Pago Total</strong>
//             </label>
//             <label className="ms-3">
//               <input
//                 type="radio"
//                 name="tipoPago"
//                 value="parcial"
//                 checked={tipoPago === 'parcial'}
//                 onChange={() => {
//                   setTipoPago('parcial');
//                   setMontoParcial('');
//                 }}
//               /> <strong>Pago Parcial</strong>
//             </label>
//           </div>

//           {tipoPago === 'parcial' && (
//             <div className="mb-3">
//               <label><strong>💳 Monto a abonar:</strong></label>
//               <input
//                 type="number"
//                 className="form-control"
//                 min={1}
//                 max={saldoPendiente - 1}
//                 step={1}
//                 value={montoParcial}
//                 onChange={e => setMontoParcial(e.target.value)}
//                 required
//               />
//               <small className="text-muted">Debe ser menor a ${saldoPendiente}</small>
//             </div>
//           )}

//           <div className="mb-3">
//             <label><strong>💳 Método de Pago:</strong></label>
//             <select
//               className="form-control"
//               value={metodoSeleccionado}
//               onChange={e => setMetodoSeleccionado(e.target.value)}
//               required
//             >
//               <option value="">Seleccione un método...</option>
//               {metodosPago.map(m => (
//                 <option key={m._id} value={m._id}>{m.name}</option>
//               ))}
//             </select>
//           </div>

//           <button
//             type="submit"
//             className="btn btn-success w-100"
//             disabled={pagando}
//           >
//             {pagando ? "Procesando..." : "💸 Realizar Pago"}
//           </button>
//         </form>
//       )}

//       {!pagoInfo.debe && (
//         <div className="alert alert-success mt-3">
//           <strong>✅ ¡Este socio está al día!</strong>
//         </div>
//       )}
//     </>
//   );
// };

const renderFormularioPago = () => {
  if (!pagoInfo) return null;

  const montoTotal = pagoInfo.finalAmount ?? pagoInfo.baseAmount ?? 0;
  const saldoPendiente = pagoInfo.saldoPendiente ?? montoTotal;
  const pagadoEsteMes = pagoInfo.pagadoEsteMes ?? 0;

  return (
    <>
      <h4 className="mb-3">Información de Pago</h4>

      <div style={{ marginBottom: '15px' }}>
        <p>
  <strong>Socio:</strong> <strong style={{ fontSize: '18px' }}>{pagoInfo.member?.name}</strong>
</p>

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <strong>Monto Cuota:</strong>
          <span>${pagoInfo.baseAmount}</span>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <strong>Descuento aplicado:</strong>
          <span>${pagoInfo.discountAmount} ({pagoInfo.discountPercentage}%)</span>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <strong>Nombre(s) del descuento:</strong>
          <span>{pagoInfo.discountNames?.length > 0 ? pagoInfo.discountNames.join(', ') : "Sin descuento"}</span>
        </div>
      </div>

      <div
        style={{
          backgroundColor: '#d3f0fa',
          padding: '16px',
          borderRadius: '8px',
          marginBottom: '20px',
          textAlign: 'center',
        }}
      >
        <p style={{ fontSize: '20px', fontWeight: 'bold', color: '#0066aa' }}>
          Total a pagar: ${montoTotal}
        </p>
        <p style={{ fontSize: '18px', fontWeight: 'bold', color: '#005577' }}>
          Pagado este mes: ${pagadoEsteMes}
        </p>
        <p style={{ fontSize: '18px', fontWeight: 'bold', color: '#005577' }}>
          Saldo pendiente: ${saldoPendiente}
        </p>
      </div>

      {pagoInfo.debe && (
        <form onSubmit={handlePagar}>
          <div className="mb-3">
            <label className="me-3">
              <input
                type="radio"
                name="tipoPago"
                value="total"
                checked={tipoPago === 'total'}
                onChange={() => {
                  setTipoPago('total');
                  setMontoParcial(saldoPendiente);
                }}
              />{" "}
              Pago Total
            </label>
            <label className="ms-3">
              <input
                type="radio"
                name="tipoPago"
                value="parcial"
                checked={tipoPago === 'parcial'}
                onChange={() => {
                  setTipoPago('parcial');
                  setMontoParcial('');
                }}
              />{" "}
              Pago Parcial
            </label>
          </div>

          {tipoPago === 'parcial' && (
            <div className="mb-3">
              <label>Monto a abonar:</label>
              <input
                type="number"
                className="form-control"
                min={1}
                max={saldoPendiente - 1}
                value={montoParcial}
                onChange={(e) => setMontoParcial(e.target.value)}
                required
              />
            </div>
          )}

          <div className="mb-3">
            <label>Método de Pago:</label>
            <select
              className="form-control"
              value={metodoSeleccionado}
              onChange={(e) => setMetodoSeleccionado(e.target.value)}
              required
            >
              <option value="">Seleccione un método</option>
              {metodosPago.map((m) => (
                <option key={m._id} value={m._id}>
                  {m.name}
                </option>
              ))}
            </select>
          </div>

          <button type="submit" className="btn btn-success w-100" disabled={pagando}>
            {pagando ? "Procesando..." : "💸 Realizar Pago"}
          </button>
        </form>
      )}

      {!pagoInfo.debe && (
        <div className="alert alert-success mt-3">
          <strong>✅ ¡Este socio está al día!</strong>
        </div>
      )}
    </>
  );
};


  return (
    <div className="container mt-4">
      <h2>Listado de Socios </h2>
      {loading && <p>Cargando...</p>}

      {!loading && (
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Documento</th>
              <th>Email</th>
              <th>Celular</th>
              <th>Cuota</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {socios.map(s => {
              const montoInfo = montos[s.id || s._id];
              let textoCuota = "Cargando...";
             if (montoInfo) {
                if (montoInfo.saldoPendiente === 0) {
                  textoCuota = <span className="text-success font-bold">${montoInfo.total} (Pagado)</span>;
                } else if (montoInfo.saldoPendiente > 0) {
                  textoCuota = <span className="text-primary font-bold">${montoInfo.saldoPendiente} (Pendiente)</span>;
                } else if (montoInfo.total !== null && montoInfo.total !== undefined) {
                  textoCuota = `$${montoInfo.total}`;
                } else if (s.precio) {
                  textoCuota = `$${s.precio}`;
                } else {
                  textoCuota = "No definido";
                }
              }

              return (
                <tr key={s.id || s._id}>
                  <td>{s.name}</td>
                  <td>{s.documento}</td>
                  <td>{s.email}</td>
                  <td>{s.celular}</td>
                  <td>
                    {textoCuota}
                  </td>
                  <td>
                    <button className="btn btn-primary btn-sm" onClick={() => handleAbrirPago(s)}>
                      Pagar
                    </button>
                  </td>
                </tr>
              )
            })}
            {socios.length === 0 && (
              <tr><td colSpan={6} className="text-center">No hay socios cargados.</td></tr>
            )}
          </tbody>
        </table>
      )}

      {/* Modal de Pago */}
      <Modal show={modalOpen} onClose={() => setModalOpen(false)}>
        {!pagoInfo && <p>Cargando información...</p>}
        {pagoInfo && pagoInfo.error && <p className="text-danger">{pagoInfo.error}</p>}
        {pagoInfo && !pagoInfo.error && renderFormularioPago()}
      </Modal>
    </div>
  );
};

export default connect(null, { setBreadcrumbItems })(Listado);

